import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { style: {"margin":"10px"} }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "Cookies are disabled!", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "You will not be able to login until you enable cookies for this site.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.whatismybrowser.com/guides/how-to-enable-cookies/auto",
  target: "_blank"
}, "Click here for instructions on how to enable cookies in your browser", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MiniDashboardHeader = _resolveComponent("MiniDashboardHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MiniDashboardHeader),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _withDirectives(_createElementVNode("input", {
          id: "usernameter",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          placeholder: "Username",
          disabled: !_ctx.cookiesEnabled
        }, null, 8, _hoisted_3), [
          [_vModelText, _ctx.username]
        ])
      ]),
      _createElementVNode("p", null, [
        _withDirectives(_createElementVNode("input", {
          id: "password",
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          placeholder: "Password",
          disabled: !_ctx.cookiesEnabled,
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
        disabled: !_ctx.cookiesEnabled
      }, "Login", 8, _hoisted_5),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true),
      (!_ctx.cookiesEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
        : _createCommentVNode("", true)
    ])
  ]))
}